import { captureEvent } from '../../../../../../../../analytics/analytics';
import { EVENT_NAMES, EVENT_TYPES } from '../../../../../../../../analytics/analytics-constants';

export const faOnTopFilterRemove = (key, value) => {
  captureEvent({
    event_type: EVENT_TYPES.USER_ACTION,
    event_name: EVENT_NAMES.BUTTON_CLICK,
    event_value: `filter_top_remove|collection_${key}_${value}`,
  });
};
